
import IQuestion, { IAnswer, Score, WeakAnswer } from "../domain/AssistantTypes";
import DataService from './DataService'
import Scores from '../domain/ResultEnums'
export default class AssistantService {

  public getQuestionsWithOptions(): IQuestion[] {
    const dataService = new DataService();
    const questions = dataService.getRawQuestions();
    questions.forEach((ques) => {
      ques.options = ques.options.sort((a, b) => a.id - b.id).filter((v, i, a) => a.findIndex(v2 => (v2.title === v.title)) === i)
    });
    return questions;
  }

  public getScores(answers: IAnswer[]): Score[] {
    const dataService = new DataService();
    const questions = dataService.getRawQuestions();
    const groups = dataService.getGroups();
    const groupScore = Object.create(Scores);

    answers.forEach((answer) => {
      const question = questions.find((q) => q.id === answer.questionId);
      groups.forEach((group) => {
        const option = question?.options.find((o) => o.title === answer.optionTitle && o.group.name == group);
        answer.optionId = option?.id!;
        if (option) groupScore[group] += option.score;
      })
    });

    const scores: Score[] = [];
    for (const key in groupScore) {
      if (groupScore[key] !== 0) {
        const degree = groupScore[key] > 100 ? 100 : groupScore[key];
        scores.push({ name: key, degree: degree });
      }
    }
    return scores;
  }

  public getSuggestion(answers: IAnswer[]): string[] {

    const questions = this.getQuestionsWithOptions();
    const weakAnswers: WeakAnswer[] = [];
    answers.forEach((answer) => {
      const question = questions.find((q) => q.id === answer.questionId);
      if (question) {
        const index = question.options.findIndex((o) => o.title === answer.optionTitle);
        weakAnswers.push({ question: question, degree: question.answerType - (index + 1) })
      }
    })
    const sortedSuggestions = weakAnswers.sort((a, b) => b.degree - a.degree);
    // .filter(s => s.degree > 0)
    return sortedSuggestions.map((v) => v.question.suggestion);
  }

  public saveUserResultInServer(answers: IAnswer[]) {
    const dataService = new DataService();

    const UserResultData = {
      answers: answers,
      groups: dataService.getGroups(),
      user: dataService.getUserInfo()
    }

    dataService.sendToServer(UserResultData);

  }
}
